import { invert } from 'lodash';

import { AUTH0_USER_ROLES } from '../roles/constants';

export default function mapAuth0UserRoleData({ roleListMap, roleId, debuggerAccess }) {
  const selectedAuth0UserRole = invert(roleListMap)[roleId];
  const roleData = { roleIds: [], roleName: selectedAuth0UserRole };

  if (selectedAuth0UserRole === AUTH0_USER_ROLES.ADMIN) {
    roleData.roleIds = [
      roleListMap[AUTH0_USER_ROLES.ADMIN],
      roleListMap[AUTH0_USER_ROLES.DEPLOYMENT_MANAGER],
      roleListMap[AUTH0_USER_ROLES.INTEGRATION_MANAGER],
      roleListMap[AUTH0_USER_ROLES.READ_ONLY],
    ];
    return injectDebuggerAccess({ roleListMap, roleData, debuggerAccess });
  }

  if (selectedAuth0UserRole === AUTH0_USER_ROLES.DEPLOYMENT_MANAGER) {
    roleData.roleIds = [
      roleListMap[AUTH0_USER_ROLES.DEPLOYMENT_MANAGER],
      roleListMap[AUTH0_USER_ROLES.INTEGRATION_MANAGER],
      roleListMap[AUTH0_USER_ROLES.READ_ONLY],
    ];
    return injectDebuggerAccess({ roleListMap, roleData, debuggerAccess });
  }

  if (selectedAuth0UserRole === AUTH0_USER_ROLES.INTEGRATION_MANAGER) {
    roleData.roleIds = [roleListMap[AUTH0_USER_ROLES.INTEGRATION_MANAGER], roleListMap[AUTH0_USER_ROLES.READ_ONLY]];
    return injectDebuggerAccess({ roleListMap, roleData, debuggerAccess });
  }

  if (selectedAuth0UserRole === AUTH0_USER_ROLES.READ_ONLY) {
    roleData.roleIds = [roleListMap[AUTH0_USER_ROLES.READ_ONLY]];
    return injectDebuggerAccess({ roleListMap, roleData, debuggerAccess });
  }
}

function injectDebuggerAccess({ roleListMap, roleData, debuggerAccess }) {
  if (debuggerAccess) {
    return { ...roleData, roleIds: [...roleData.roleIds, roleListMap[AUTH0_USER_ROLES.READ_EVENTS]] };
  }
  return roleData;
}
